import Vue from 'vue'
//该文件专门用于创建整个应用的路由器
import VueRouter from 'vue-router'
// 1.把所有要用的组件全部引入
import Index from '../views/Index.vue'
import BusinessList from '../views/BusinessList.vue'
import BusinessInfo from '../views/BusinessInfo.vue'
import Login from '../views/Login.vue'
import Orders from '../views/Orders.vue'
import UserAddress from '../views/UserAddress.vue'
import Payment from '../views/Payment.vue'
import OrderList from '../views/OrderList.vue'
import AddUserAddress from '../views/AddUserAddress.vue'
import EditUserAddress from '../views/EditUserAddress.vue'
import Register from '../views/Register.vue'
import Me from '../views/Me.vue'
import Transaction from '../views/transaction.vue';

// 2.Vue.use来使用插件库
Vue.use(VueRouter)
// 3.，定义路由，申明routes，component是创建的组件
const routes = [{
  path: '/',
  name: 'Home',
  component: Index
}, {
  path: '/index',
  name: 'Index',
  component: Index
}, {
  path: '/businessList',
  name: 'BusinessList',
  component: BusinessList
}, {
  path: '/businessInfo',
  name: 'BusinessInfo',
  component: BusinessInfo
}, {
  path: '/login',
  name: 'Login',
  component: Login
}, {
  path: '/orders',
  name: 'Orders',
  component: Orders
}, {
  path: '/userAddress',
  name: 'UserAddress',
  component: UserAddress
}, {
  path: '/payment',
  name: 'Payment',
  component: Payment
}, {
  path: '/orderList',
  name: 'OrderList',
  component: OrderList
}, {
  path: '/addUserAddress',
  name: 'AddUserAddress',
  component: AddUserAddress
}, {
  path: '/editUserAddress',
  name: 'EditUserAddress',
  component: EditUserAddress
}, {
  path: '/register',
  name: 'Register',
  component: Register
}, {
  path: '/me',
  name: 'Me',
  component: Me
},{
  path:'/transaction',
  name:'Transaction',
  component: Transaction
}
]
//解决重复路由报异常问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
// 创建router实例
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
//暴露路由
export default router